import React from 'react'
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useEffect } from "react";
import { getCustomer } from "../data/customer.api";
import CustomTable from "../../../shared/CustomTable";
import { InterfaceCustomerData } from "../data/customer.interface";
import { Delete, Edit } from "@mui/icons-material";

export default function CustomerTable(props: {
    onEdit?: (data: InterfaceCustomerData) => void,
    onDelete?: (id: number) => void,
    onSelect?: (data: InterfaceCustomerData) => void,
    selectedId?: number
}) {

    const dispatch = useDispatch<any>()

    const { customerList } = useSelector((state: RootState) => state.customer)

    useEffect(() => {
        dispatch(getCustomer())
    }, [dispatch])

    return (
        <Box>
            <CustomTable
                columns={[
                    {
                        name: "Nama",
                        key: "name"
                    },
                    {
                        name: "HP",
                        key: "phone"
                    }
                ]}
                dataList={customerList}
                actionList={(props.onEdit || props.onDelete || props.onSelect)
                    ? (data: InterfaceCustomerData) => (
                        <Box display={"flex"} justifyContent={"center"} gap={1}>
                            {props.onEdit && (<Button startIcon={<Edit />} color="warning" onClick={() => props.onEdit && props.onEdit(data)}>Edit</Button>)}
                            {props.onDelete && (<Button startIcon={<Delete />} color="error" onClick={() => props.onDelete && props.onDelete(data.id)}>Hapus</Button>)}
                            {(props.onSelect && data.id !== props.selectedId) && (<Button onClick={() => props.onSelect && props.onSelect(data)}>Pilih</Button>)}
                        </Box>
                    )
                    : undefined
                }
            />
        </Box>
    )
}